import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image } from '@platzi/ui';
import styles from './Banner.module.sass';

export interface BannerProps {
  image: string;
  description: string;
  title: string;
  id: string;
}
export const Banner = (props: BannerProps) => {
  const { t } = useTranslation();
  const isLogged = useSelector((state) => state.get('header')).get('isLogged') || false;
  const [show, setShow] = useState(false);

  useEffect(() => {
    const showBannerLocalStorage = localStorage.getItem(props.id);

    if (showBannerLocalStorage === 'false') {
      setShow(false);
    } else {
      setShow(true);
    }
  }, [props.id]);

  const handleCloseBanner = () => {
    localStorage.setItem(props.id, 'false');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className={`${styles.Container} ${props.id === 'whatIsPlatziBanner' && styles.ContainerBackgroundImage}`}>
      {isLogged && (
        <div className={styles.CloseButtonCont} onClick={handleCloseBanner}>
          <FontAwesomeIcon icon={faClose} />
        </div>
      )}
      <Image src={props.image} alt={t(props.title)} customClass={styles.Image} />
      <div className={styles.Content}>
        <p className={styles.Title}>{t(props.title)}</p>
        <p className={styles.Description}>{t(props.description)}</p>
      </div>
    </div>
  );
};
